var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4286 16.7142V2.99993C13.4286 2.54527 13.2479 2.10924 12.9265 1.78775C12.605 1.46626 12.1689 1.28564 11.7143 1.28564H8.2857C7.83104 1.28564 7.39501 1.46626 7.07352 1.78775C6.75203 2.10924 6.57142 2.54527 6.57142 2.99993V16.7142M3.14284 4.71422H16.8571C17.8039 4.71422 18.5714 5.48173 18.5714 6.4285V14.9999C18.5714 15.9467 17.8039 16.7142 16.8571 16.7142H3.14284C2.19607 16.7142 1.42856 15.9467 1.42856 14.9999V6.4285C1.42856 5.48173 2.19607 4.71422 3.14284 4.71422Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.49d3ec3e7037b0f0bb0ecbec88b4b86f.svg";
export { ForwardRef as ReactComponent };